export const CDK_ORDER_TYPE: any = [
  {
    label: 'O, Stock Order',
    value: ' '
  },
  {
    label: 'N, Stock Order',
    value: 'N'
  },
  {
    label: 'S, Supplemental Order',
    value: 'S'
  },
  {
    label: 'C, Customer Order',
    value: 'C'
  },
  {
    label: 'T, Transfer Order',
    value: 'T'
  },
  {
    label: 'F, Force Order',
    value: 'F'
  },
  {
    label: 'B, Backorder (regular)',
    value: 'B'
  },
  {
    label: 'K, Customer Backorder',
    value: 'K'
  },
  {
    label: 'X, Supplemental Backorder',
    value: 'X'
  }
];

export const CDK_VDI_FLAG: any = [
  {
    label: 'Yes',
    value: 'Yes'
  }]